import { routes } from "consts";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useToaster } from "utils";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { ExamForm, ExamFormValues } from "./ExamForm";
import { examsApi } from "api/examsApi";
import { PaziaLoader } from "components/atoms";
import { QUERIES_KEYS } from "queries";
import { queryClient } from "main";
import { useExam } from "api/hooks/useExam";

export const ExamEditPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();
  const { examId } = useParams();

  const { isLoading, exam } = useExam(examId);

  const onSubmit = async (data: ExamFormValues) => {
    try {
      await examsApi.update(Number(examId), data);
      navigate(routes.EXAMS);
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.SINGLE_EXAM(examId!) });
      showSuccess("Egzamin została zaktualizowany.");
    } catch (e) {
      console.error(e);
      showError("Nie udało się zaktualizować egzaminu.");
    }
  };

  if (isLoading) return <PaziaLoader position="center" />;
  if (!exam) return null;
  const breadcrumbs = [{ title: "Egzaminy", path: routes.EXAMS }, { title: exam.name }];

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Edycja egzaminu" />
      <ExamForm onSubmit={onSubmit} exam={exam} />
    </PageMain>
  );
};
